import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('clientToken');
  const user = localStorage.getItem('clientUser');
  
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }
  
  // Verify token is not expired (basic check)
  try {
    const userData = JSON.parse(user);
    if (!userData.id) {
      localStorage.removeItem('clientToken');
      localStorage.removeItem('clientUser');
      return <Navigate to="/login" replace />;
    }
  } catch (error) {
    localStorage.removeItem('clientToken');
    localStorage.removeItem('clientUser');
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default ProtectedRoute;

